import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import type { Locale } from "../localization/constants";
import { ActionType } from "../types/participantProgress";

export const buildActionTypeEnumValues = (
  locale: Locale = getAdminUiLocale()
): Record<ActionType, string> => {
  const t = getAdminT(locale);
  return Object.fromEntries(
    Object.values(ActionType).map((value) => [value, t(`actionTypes.${value}`)])
  ) as Record<ActionType, string>;
};

export const actionTypeLabel = (
  actionType: string,
  locale: Locale = getAdminUiLocale()
): string => {
  const labels = buildActionTypeEnumValues(locale);
  return labels[actionType as ActionType] ?? actionType;
};
